import axios from "axios";
import 'react-dotenv';
//const BASE_URL = 'https://api.garmenzo.com/api/v1';

const axiosPrivate = axios.create({
    baseURL: process.env.REACT_APP_API_URL,// || BASE_URL,
    headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    timeout: 10000, // 10 second timeout
});

axiosPrivate.interceptors.request.use(
    config => {
        console.log('process.env.REACT_APP_API_URL',process.env.REACT_APP_API_URL);
        // No authorization header needed for this API
        return config;
    }, (error) => Promise.reject(error)
);

axiosPrivate.interceptors.response.use(
    (response) => response?.data || response,
    async (error) => {
        const originalRequest = error.config;

        // Handle 401 errors (if needed in future)
        if ((error.response?.status === 401) && !originalRequest._retry) {
            originalRequest._retry = true;
            console.log('401 Unauthorized - No auth required for this API');
        }
        if (error.response?.status === 500) {
            //return Promise.reject('Some error occured while processing the request. Please try again.');
            return Promise.reject(error);
            //return error.response?.data || error.response;
        }
  
        return Promise.reject(error);
    }
);

export default axiosPrivate;